import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditProfileForm from './EditProfileForm'
import ModalHeader from './ModalHeader'
import ProfileLoader from './_load/ProfileLoader'

const EditProfileModal = props => {
  return (
    <ControlledModal width="28rem" {...props}>
      <PermissionChecker ownerOnly>
        <ModalHeader />
        <ProfileLoader>
          <EditProfileForm />
        </ProfileLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditProfileModal
